import { Media } from '@/interfaces/media';
import { MediaResource, mediaResource } from '@/resources/media.resource';
import { EntityModule } from './entity.module';

/**
 * Moduł Plików
 *
 * @export
 * @class MediaModule
 * @extends {EntityModule<Media, MediaResource>}
 */
export class MediaModule extends EntityModule<Media, MediaResource> {
  constructor() {
    super(mediaResource);
    this.state = {
      ...this.state,
      isUploading: false
    } as any;
    this.mutations = {
      ...this.mutations,
      /**
       *  Ustawa status pliku
       *
       * @param {*} localState
       * @param {boolean} value
       */
      setIsUploading(localState: any, value: boolean): void {
        localState.isUploading = value;
      }
    };
    this.actions = {
      ...this.actions,
      listByIds: async (context, mediaIds: [number]) => {
        const list = await this.resource.listByIds(mediaIds);
        context.commit('saveList', list);
      }
    };
  }
}

export default new MediaModule();
